export const VENDOR_FILTER_ALL = "all";

export interface VendorListFilterValues {
  search: string;
  categoryId: string;
  vendorType: string;
  stateId: string;
  districtId: string;
  cityId: string;
  verificationStatus: string;
  availableForWork: string;
}

export const initialVendorFilters: VendorListFilterValues = {
  search: "",
  categoryId: VENDOR_FILTER_ALL,
  vendorType: VENDOR_FILTER_ALL,
  stateId: VENDOR_FILTER_ALL,
  districtId: VENDOR_FILTER_ALL,
  cityId: VENDOR_FILTER_ALL,
  verificationStatus: VENDOR_FILTER_ALL,
  availableForWork: VENDOR_FILTER_ALL,
};

/** Counts dropdown filters inside the expandable panel (excludes search). */
export function countActivePanelFilters(
  filters: VendorListFilterValues
): number {
  let count = 0;
  if (filters.categoryId !== VENDOR_FILTER_ALL) {
    count += 1;
  }
  if (filters.vendorType !== VENDOR_FILTER_ALL) {
    count += 1;
  }
  if (filters.stateId !== VENDOR_FILTER_ALL) {
    count += 1;
  }
  if (filters.districtId !== VENDOR_FILTER_ALL) {
    count += 1;
  }
  if (filters.cityId !== VENDOR_FILTER_ALL) {
    count += 1;
  }
  if (filters.verificationStatus !== VENDOR_FILTER_ALL) {
    count += 1;
  }
  if (filters.availableForWork !== VENDOR_FILTER_ALL) {
    count += 1;
  }
  return count;
}

export function countActiveVendorFilters(
  filters: VendorListFilterValues
): number {
  return (filters.search.trim() ? 1 : 0) + countActivePanelFilters(filters);
}
